<template>
	<div>
		<Head :title="reminder.title" />

		<Breadcrumbs
			href="/reminders"
			:parentLabel="__('Reminders')"
			:childLabel="reminder.title"
		/>

		<TrashedMessage v-if="reminder.deleted_at" class="mb-6">
			{{ __('This reminder has been deleted.') }}
		</TrashedMessage>

		<div class="max-w-full overflow-hidden rounded-md bg-white shadow">
			<ReminderForm :submit="update" :model="reminder" :products="products.data" :regions="regions.data" :roles="roles.data" :label="__('Update reminder')" />
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TrashedMessage from '@/Shared/TrashedMessage'
	import Breadcrumbs 	  from '@/Shared/Breadcrumbs'
	import ReminderForm   from './ReminderForm'

	export default {
		components: {
			Head,
			Breadcrumbs,
			TrashedMessage,
			ReminderForm,
		},
		layout: Layout,
		props: {
			reminder: Object,
			products: Object,
			regions: Object,
			roles: Object,
		},
		data() {
			return {}
		},
		methods: {
			update(form, preview = false) {
				form.put(`/reminders/${ this.reminder.id }/${ preview }`)
			}
		}
	}
</script>
